/** @jsx h */
/* global H */
import { h, cloneElement, Component } from 'preact'
import deepEqual from 'fast-deep-equal'
import Theme from './theme'
import { addListenersFromProps, removeListenersFromProps } from '../utils/listeners'

class Cluster extends Component {
  constructor (props) {
    super(props)

    this.provider = new H.clustering.Provider([], {
      clusteringOptions: {
        eps: 32,
        minWeight: 2
      }
    })
    this.provider.setTheme(new Theme(1))
    this.layer = new H.map.layer.ObjectLayer(this.provider)
  }

  componentDidMount () {
    this.props.map.addLayer(this.layer)
    addListenersFromProps(this.provider, this.props)
  }

  shouldComponentUpdate ({ dataPoints }) {
    return !deepEqual(this.props.dataPoints, dataPoints)
  }

  componentDidUpdate (prevProps) {
    addListenersFromProps(this.provider, this.props, {
      filter: ({ prop }) => !prevProps[prop]
    })

    removeListenersFromProps(this.provider, prevProps, {
      filter: ({ prop }) => !this.props[prop]
    })
  }

  componentWillUnmount () {
    this.props.map.removeLayer(this.layer)
    removeListenersFromProps(this.provider, this.props)
  }

  render ({ dataPoints }) {
    this.provider.setDataPoints(
      dataPoints.map(args => new H.clustering.DataPoint(...args))
    )

    return null
  }
}

class DataPoint extends Component {
  render () {
    return null
  }
}

Cluster.DataPoint = DataPoint
export default Cluster
